import { render, staticRenderFns } from "./selectDownCustomer.vue?vue&type=template&id=555cf33c&scoped=true&"
import script from "./selectDownCustomer.vue?vue&type=script&lang=js&"
export * from "./selectDownCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555cf33c",
  null
  
)

export default component.exports